export default __webpack_public_path__ + "static/media/va2014.b1bcdc5a.jpg";